import { render, staticRenderFns } from "./monthly-transaction-chart.vue?vue&type=template&id=cb56dcec&scoped=true"
import script from "./monthly-transaction-chart.vue?vue&type=script&lang=js"
export * from "./monthly-transaction-chart.vue?vue&type=script&lang=js"
import style0 from "./monthly-transaction-chart.vue?vue&type=style&index=0&id=cb56dcec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb56dcec",
  null
  
)

export default component.exports